<template>
  <div style="padding-top:-2px;margin-top:-2px;">
    <v-label v-if="label"><b>{{ label }}</b></v-label>
    <s-select-generic
      ref="sgeneric"
      autocomplete
      :config="config"
      :disabled="disabled"
      :readonly="readonly"
      :itemvalue="id"
      :itemtext="itemText"
      :clearable="clearable"
      :full="full"
      :id="id"
      :value="value"
      @input="input($event)"
      @change="change($event)"
      :returnObject="returnObject"
    />
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "SSelectEstablishment",
  props: {
    id: {
      type: String,
      default: "EstID",
    },
    itemText: {
      type: String,
      default: "EstDescription",
    },
    value: null,
    label: {
      type: String,
      default: "Establecimiento/Planta",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      config: {
        url: Vue.prototype.$http.defaults.baseURL + "/HmnEstablishment/list",
        title: "",
        params: {
          requestID: 0,
        },
      },
    };
  },
  methods: {
    input(item) {
      this.$emit("input", item);
      this.$emit("change", item);
    },
    change(item) {
      this.$emit("change", item);
    },
    focus() {
      const g = this.$refs.sgeneric;
      if (g && typeof g.focus === "function") {
        g.focus();
      }
    },
    error(msg) {
      const g = this.$refs.sgeneric;
      if (g && typeof g.error === "function") {
        g.error(msg);
      }
    },
  },
  created() {
    this.config.title = this.label;
    this.config.params.requestID = this.$fun.getUserID();
  },
};
</script>
